import { trans } from '@spotahome/soyuz/client';
import PropTypes from 'prop-types';

import {
  FREQUENCY_BI_MONTHLY,
  FREQUENCY_MONTHLY,
  FREQUENCY_ONE_PAYMENT,
  FREQUENCY_WEEKLY,
  PAYMENT_METHOD_BANK_TRANSFER,
  PAYMENT_METHOD_CASH,
  PAYMENT_METHOD_CREDIT_CARD,
  PAYMENT_METHOD_PAY_THROUGH_SPOTAHOME,
  PAYMENT_METHOD_PAY_TO_PROVIDER,
  PAYMENT_METHOD_PAYPAL,
  PAYMENT_TO_LANDLORD,
  PAYMENT_TO_SPOTAHOME
} from '../../constants/costs';

import { FREQUENCY_DICTIONARY } from './constants';

import styles from './PaymentTimelineSubtitle.module.scss';

const PaymentTimelineSubtitle = ({
  from = null,
  to = null,
  paymentTo = null,
  frequency = null,
  paymentOptions = []
}) => {
  const paymentOptionsLabels = paymentOptions.map(o =>
    trans(`payment.timeline.paymentMethod.${o}`)
  );

  const paymentInfo = [
    paymentTo &&
      trans(`booking_request.spotahome_booking_payment_info.${paymentTo}`),
    FREQUENCY_DICTIONARY[frequency] && trans(FREQUENCY_DICTIONARY[frequency]),
    paymentOptions.length > 0 &&
      paymentOptionsLabels.join(` ${trans('payment.timeline.or')} `)
  ].filter(Boolean);

  return (
    <div className={styles['payment-timeline-subtitle']}>
      {from && to && (
        <div>
          {trans(
            'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.hint',
            {
              from,
              to
            }
          )}
        </div>
      )}
      {(paymentTo || frequency || paymentOptions.length > 0) && (
        <div>{paymentInfo.join(' · ')}</div>
      )}
    </div>
  );
};
PaymentTimelineSubtitle.propTypes = {
  from: PropTypes.string,
  to: PropTypes.string,
  paymentTo: PropTypes.oneOf([PAYMENT_TO_LANDLORD, PAYMENT_TO_SPOTAHOME]),
  frequency: PropTypes.oneOf([
    FREQUENCY_MONTHLY,
    FREQUENCY_BI_MONTHLY,
    FREQUENCY_WEEKLY,
    FREQUENCY_ONE_PAYMENT
  ]),
  paymentOptions: PropTypes.arrayOf(
    PropTypes.oneOf([
      PAYMENT_METHOD_CASH,
      PAYMENT_METHOD_BANK_TRANSFER,
      PAYMENT_METHOD_CREDIT_CARD,
      PAYMENT_METHOD_PAY_TO_PROVIDER,
      PAYMENT_METHOD_PAY_THROUGH_SPOTAHOME,
      PAYMENT_METHOD_PAYPAL
    ])
  )
};

export default PaymentTimelineSubtitle;
